/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { User } from "@auth0/auth0-react";
import userflow from "userflow.js";
import { USERFLOW_TOKEN } from "./config";

/* eslint-disable unicorn/consistent-function-scoping -- inner scoping is fine in this case */

export function useUserflow() {
  const initialize = (user?: User) => {
    if (user) {
      userflow.init(USERFLOW_TOKEN);
      userflow.setPageTrackingDisabled(true);
      if (user.email) {
        void userflow.identify(user.email);
      }
    }
  };

  const start = (contentId: string) => {
    void userflow.start(contentId);
  };

  return { initialize, start };
}
